import { SxProps } from '@mui/material';

import StyledAvatar from '@webclient/components/avatar/styles';

type Props = {
  url?: string;
  alt?: string;
  size: number;
  sx?: SxProps;
};

export default function Avatar({ url, alt, size, sx }: Props) {
  return (
    <StyledAvatar
      sx={{
        height: size,
        width: size,
        ...sx,
      }}
      src={url ?? undefined}
      alt={alt}
    />
  );
}
